<template>
  <v-snackbar
    v-model="show"
    :color="color"
  >
    {{ message }}
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: '',
      color: '',
    };
  },

  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setSnackbar') {
        this.message = state.snackbar.text;
        this.color = state.snackbar.color;
        this.show = true;
      }
    });
  },
};
</script>
